import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Alert, Col, FormFeedback, FormGroup, Input, Label} from "reactstrap";
import useAfterUpdateEffect from "../../../../utils/useAfterUpdateEffect";
import useDidMountEffect from "../../../../utils/useDidMountEffect";
import {useSelector} from "react-redux";
import {
  DOCUMENT_STATUS_ACCEPTED, DOCUMENT_STATUS_COMPLETED,
  DOCUMENT_STATUS_CONFIRMED,
  DOCUMENTS_TYPE_REQUISITION, DocumentStatusSelect, DocumentsTypeSelect
} from "../../SupplierForm/SupplierInterCarsFields";
import {useTranslation} from "react-i18next";

const InterCars = props => {
  const { t } = useTranslation('supplier_create')
  const user = useSelector(state => state.user)
  const [data, setData] = useState({
    clientNumber: '',
    email: user.email,
    signedContract: null,
    documentsType: DOCUMENTS_TYPE_REQUISITION,
    documentStatus: DOCUMENT_STATUS_CONFIRMED,
  })

  useDidMountEffect(() => {
    props.onChange(data)
  })

  useAfterUpdateEffect(() => {
    props.onChange(data)
  }, [data])

  return <React.Fragment>
    <Alert color={'info'}>
      <p>{t('supplier.interCars.text1')}</p>
      <p className="mb-0">{t('supplier.interCars.text2')}</p>
      <div className="d-flex flex-column">
        <a href="/umowy/umowa-ic-jdg.docx" target="_blank"><i className="fas fa-download mr-2" /><span>{t('supplier.interCars.agreement1')}</span></a>
        <a href="/umowy/umowa-ic-sp-zoo.docx" target="_blank"><i className="fas fa-download mr-2" /><span>{t('supplier.interCars.agreement2')}</span></a>
        <a href="/umowy/umowa-sp-cywilna-lub-jawna.docx" target="_blank"><i className="fas fa-download mr-2" /><span>{t('supplier.interCars.agreement3')}</span></a>
        <a href="/umowy/umowa-ic-sa.docx" target="_blank"><i className="fas fa-download mr-2" /><span>{t('supplier.interCars.agreement4')}</span></a>
      </div>
      <Alert className="mb-0 mt-2" color="warning">
        <strong>{t('supplier.interCars.alert')}</strong>
      </Alert>
    </Alert>
    <FormGroup row>
      <Label md={3}>{t('supplier.interCars.client_number')}</Label>
      <Col md="9">
        <Input
          invalid={!!props.errors?.clientNumber?.errors}
          placeholder={t('supplier.interCars.client_number_placeholder')}
          onChange={e => setData({...data, clientNumber: e.target.value,})}
          value={data.clientNumber}
        />
        <FormFeedback>{props?.errors?.clientNumber?.errors?.join('; ')}</FormFeedback>
      </Col>
    </FormGroup>
    <FormGroup row>
      <Label md={3}>
        <span>{t('supplier.interCars.email')}</span>
        <div style={{ lineHeight: '10px'}}>
          <small className="text-secondary">{t('supplier.interCars.email_hint')}</small>
        </div>
      </Label>
      <Col md="9">
        <Input
          invalid={!!props.errors?.email?.errors}
          placeholder={t('supplier.interCars.email')}
          onChange={e => setData({...data, email: e.target.value,})}
          value={data.email}
        />
        <FormFeedback>{props?.errors?.email?.errors?.join('; ')}</FormFeedback>
      </Col>
    </FormGroup>
    <FormGroup row>
      <Label md={3}>{t('supplier.interCars.signed_contract')}</Label>
      <Col md="9">
        <Input
          type={'file'}
          invalid={!!props?.errors?.signedContract?.errors}
          placeholder={t('supplier.interCars.signed_contract_placeholder')}
          onChange={e => setData({...data, signedContract: e.target.files[0]})}
        />
        <FormFeedback>{props?.errors?.signedContract?.errors?.join('; ')}</FormFeedback>
      </Col>
    </FormGroup>
    {(data.clientNumber && data.signedContract) && <React.Fragment>
      <FormGroup row>
        <Label md={3}>{t('supplier.interCars.documents_type')}</Label>
        <Col md="9">
          <DocumentsTypeSelect
            value={data.documentsType}
            onChange={documentsType => setData({...data, documentsType})}
          />
          {props.errors.documentsType?.errors && <FormFeedback className="d-block">{props.errors.documentsType?.errors?.join('; ')}</FormFeedback>}
        </Col>
      </FormGroup>
      {data.documentsType === DOCUMENTS_TYPE_REQUISITION && <FormGroup row>
        <Label md={3}>{t('supplier.interCars.document_status')}</Label>
        <Col md="9">
          <DocumentStatusSelect
            value={data.documentStatus}
            onChange={documentStatus => setData({...data, documentStatus})}
          />
          {props.errors.documentStatus?.errors && <FormFeedback className="d-flex">{props.errors.documentStatus?.errors?.join('; ')}</FormFeedback>}
          {data.documentStatus && <Alert color={'info'} className="mt-2 p-2 d-flex flex-row flex-nowrap align-items-center">
            <i className="fas fa-info-circle fa-2x mr-2" />
            <span>{t(`supplier.interCars.document_status_select.${data.documentStatus}.description`)}</span>
          </Alert>}
        </Col>
      </FormGroup>}
    </React.Fragment>}
  </React.Fragment>
};

InterCars.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default InterCars;